import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import Seo from '../components/Seo';

const TermsOfService = () => {
  return (
    <>
      <Seo title="Terms of Service" description="MoodCraft terms of service." canonicalPath="/terms-of-service" />
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Lato", sans-serif' }}>
            Terms of Service
          </Typography>
          <Divider sx={{ mb: 4 }} />
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            By accessing or using MoodCraft, you agree to be bound by these Terms of Service...
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            2. Description of Service
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            MoodCraft provides tools for mood tracking, journaling, and mental health resources. We do not provide medical advice, diagnosis, or treatment. Our service is not a substitute for professional medical advice, diagnosis, or treatment.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            3. User Accounts
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            To use certain features of our service, you must register for an account. You are responsible for safeguarding your account and for all activities that occur under your account.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            4. Content and Conduct
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            You retain ownership of any content you submit to the service. By submitting content, you grant us a worldwide, non-exclusive license to use, reproduce, and display your content in connection with the service.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            5. Termination
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            We may terminate or suspend your account at any time, without prior notice or liability, for any reason, including if you breach the Terms of Service.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            6. Disclaimer of Warranties
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            The service is provided "as is" and "as available" without warranties of any kind, either express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: '"Quicksand", sans-serif' }}>
              Last updated: {new Date().toLocaleDateString()}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default TermsOfService;
